import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Poder } from 'src/app/modelos/poder';
import { PoderService } from 'src/app/services/poder.service';


@Component({
  selector: 'app-poder-qr',
  templateUrl: './poder-qr.component.html',
  styleUrls: ['./poder-qr.component.css']
})
export class PoderQrComponent implements OnInit {

  TipoPermiso:string = '';
  contratantes:any;
  poder: Poder = new Poder();

  constructor(private rutaActiva: ActivatedRoute,private poderService:PoderService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.spinner.show();
    this.poderService.ObtenerPorCuid(this.rutaActiva.snapshot.params.id).subscribe(response => {
      this.spinner.hide();  
      this.poder = response.poderes[0];

      this.contratantes = response.participantes;
     
     
    });


  }

}
